// OAuth callback page — receives token from URL fragment after Google redirect
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function OAuthCallback() {
  const navigate = useNavigate();
  const { setAuthFromOAuth, user } = useAuth();
  const tokenApplied = useRef(false);

  // Step 1: Extract token from hash and apply auth state
  useEffect(() => {
    if (tokenApplied.current) return;
    try {
      const hash = window.location.hash.substring(1); // remove #
      const params = new URLSearchParams(hash);
      const token = params.get('token');
      const userJson = params.get('user');

      if (token && userJson) {
        const apiUser = JSON.parse(userJson);
        tokenApplied.current = true;
        setAuthFromOAuth(token, apiUser);
      } else {
        navigate('/login?error=oauth_failed', { replace: true });
      }
    } catch {
      navigate('/login?error=oauth_failed', { replace: true });
    }
  }, [navigate, setAuthFromOAuth]);

  // Step 2: Navigate once user state is set (React state committed)
  useEffect(() => {
    if (tokenApplied.current && user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center">
      <div className="animate-pulse text-text-secondary">Completing sign-in...</div>
    </div>
  );
}
